var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07812 12C0.667969 12 0.375 12.3516 0.375 12.7031V27.9375C0.375 29.5195 1.60547 30.75 3.1875 30.75H23.8125C25.3359 30.75 26.625 29.5195 26.625 27.9375V12.7031C26.625 12.3516 26.2734 12 25.9219 12H1.07812ZM26.625 9.42188V7.3125C26.625 5.78906 25.3359 4.5 23.8125 4.5H21V1.45312C21 1.10156 20.6484 0.75 20.2969 0.75H17.9531C17.543 0.75 17.25 1.10156 17.25 1.45312V4.5H9.75V1.45312C9.75 1.10156 9.39844 0.75 9.04688 0.75H6.70312C6.29297 0.75 6 1.10156 6 1.45312V4.5H3.1875C1.60547 4.5 0.375 5.78906 0.375 7.3125V9.42188C0.375 9.83203 0.667969 10.125 1.07812 10.125H25.9219C26.2734 10.125 26.625 9.83203 26.625 9.42188Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyCalendar);
export default __webpack_public_path__ + "static/media/monthly-calendar.1f38e62e8ef0c327e646abd394be45a8.svg";
export { ForwardRef as ReactComponent };